import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  MdSearch,
  MdClear,
  MdDownload,
  MdChevronLeft,
  MdChevronRight,
  MdFirstPage,
  MdLastPage,
} from "react-icons/md";
import BulkImportButton from "components/common/BulkImportButton";


import { fetchOrganizerEvents, deleteEvent } from "api/events.api";
import EventsTable from "components/events/EventsTable";

export default function Events() {
  const [data, setData] = useState([]);
  const [alert, setAlert] = useState("");

  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [selectedOrganizer, setSelectedOrganizer] = useState(
    localStorage.getItem("company_id") || ""
  );

  const userId = "69579c6190a653b640e65639";

  const formatDateTime = (iso) => {
      if (!iso) return "-";

      const d = new Date(iso);

      return d.toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    };

    const handleDelete = async (id) => {

    await deleteEvent(id, {
      is_deleted: true,
      deleted_by: userId,
    });

    setAlert("Exhibitor deleted successfully");
    fetchData();
  };


  const fetchData = async () => {
    const res = await fetchOrganizerEvents(selectedOrganizer || undefined);
    setData(Array.isArray(res.data?.data) ? res.data.data : []);
  };

  useEffect(() => {
    fetchData();
  }, [selectedOrganizer]);

  useEffect(() => {
    const handleOrganizerChange = (e) => {
      setSelectedOrganizer(e.detail);
    };
    window.addEventListener("companyChanged", handleOrganizerChange);
    return () =>
      window.removeEventListener("companyChanged", handleOrganizerChange);
  }, []);

  const filteredData = data.filter(
    (item) =>
      item.event_name?.toLowerCase().includes(search.toLowerCase()) ||
      item.description?.toLowerCase().includes(search.toLowerCase())
  );

  const totalPages = Math.ceil(filteredData.length / limit);

  const paginatedData = filteredData.slice(
    (page - 1) * limit,
    page * limit
  );

  const exportCSV = () => {
    const headers = ["Event Name", "From Date", "From Time", "To Date", "To Time", "Status"];
    const rows = filteredData.map((e) => [
      e.event_name,
      formatDateTime(e.from_date),
      formatDateTime(e.to_date),
      e.status,
    ]);

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers, ...rows].map((r) => r.join(",")).join("\n");

    const link = document.createElement("a");
    link.href = encodeURI(csvContent);
    link.download = "events.csv";
    link.click();
  };

  return (
    <div className="p-4">
      {/* Header */}
      <div className="flex justify-between items-center mb-4">
        <div className="flex items-center gap-2">
          {/* Search */}
          <div className="relative">
            <MdSearch className="absolute left-3 top-2.5 text-gray-400 text-lg" />
            <input
              type="text"
              placeholder="Search events..."
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setPage(1);
              }}
              className="pl-10 pr-8 py-2 border rounded-md text-sm w-64 focus:outline-none focus:ring-1 focus:ring-brand-500"
            />

            {search && (
              <button
                onClick={() => setSearch("")}
                className="absolute right-2 top-2.5 text-gray-400 hover:text-gray-600"
              >
                <MdClear />
              </button>
            )}
          </div>

          {/* CSV */}
          <button
            onClick={exportCSV}
            className="flex items-center gap-1 px-2 py-1 bg-green-500 text-white rounded-lg"
          >
            <MdDownload />
            CSV
          </button>
        </div>

        {/* Add */}
        <div className="flex items-center gap-2">
          <BulkImportButton module="events" label="Import Events" onSuccess={fetchData} companyId={selectedOrganizer} />
        <Link
          to="/admin/events/create"
          className="bg-brand-500 hover:bg-brand-600 text-white px-4 py-2 rounded-md text-sm font-medium"
        >
          Add Event
        </Link>
      </div>
       </div>

      {/* Table */}
      <div className="bg-white rounded-md shadow-sm border">
        <EventsTable
          data={paginatedData}
          onRefresh={fetchData}
          onDelete={handleDelete}
        />

        {/* Pagination */}
        <div className="flex justify-between items-center px-4 py-3 border-t text-sm">
          <span className="text-gray-500">
            {filteredData.length} total
          </span>

          <div className="flex items-center gap-1">
            <select
              value={limit}
              onChange={(e) => {
                setLimit(Number(e.target.value));
                setPage(1);
              }}
              className="border rounded-md px-2 py-2 text-sm"
            >
              <option value={10}>10 / page</option>
              <option value={25}>25 / page</option>
              <option value={50}>50 / page</option>
            </select>

            <button
              disabled={page === 1}
              onClick={() => setPage(1)}
              className="p-2 border rounded hover:bg-gray-100 disabled:opacity-40"
            >
              <MdFirstPage />
            </button>

            <button
              disabled={page === 1}
              onClick={() => setPage(page - 1)}
              className="p-2 border rounded hover:bg-gray-100 disabled:opacity-40"
            >
              <MdChevronLeft />
            </button>

            <span className="px-3 font-medium">
              {page} / {totalPages || 1}
            </span>

            <button
              disabled={page === totalPages}
              onClick={() => setPage(page + 1)}
              className="p-2 border rounded hover:bg-gray-100 disabled:opacity-40"
            >
              <MdChevronRight />
            </button>

            <button
              disabled={page === totalPages}
              onClick={() => setPage(totalPages)}
              className="p-2 border rounded hover:bg-gray-100 disabled:opacity-40"
            >
              <MdLastPage />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
